var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExclamation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.23632 14.1813C7.09076 14.3246 7 14.5262 7 14.7494V25.0646C7 25.33 7 25.5 7.32451 25.888L12.2272 32.6799C12.3719 32.8812 12.6022 33 12.8471 33H28.2856C28.5305 33 28.7617 32.8805 28.9064 32.6781L33.8399 25.8037C33.9289 25.6791 33.9794 25.5332 33.9871 25.3845C33.9957 25.3391 34 25.2926 34 25.245V14.7494C34 14.6595 33.9846 14.5732 33.958 14.4928C33.9324 14.4059 33.893 14.3226 33.8382 14.2472L28.8387 7.3201C28.6932 7.11874 28.4628 7 28.2188 7H12.7803C12.5346 7 12.3043 7.11952 12.1587 7.32186L7.23632 14.1813ZM32.4588 24.4559V15.2131L27.8301 8.5773H13.1699L8.51636 15.1071L8.54119 24.4564H8.56431V24.4638L13.2358 31.4227H27.8952L32.4948 24.4673L32.4588 24.4559Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8465 22.7419V12.6512C21.8465 12.0923 21.3935 11.6393 20.8346 11.6393C20.2758 11.6393 19.8228 12.0923 19.8228 12.6512V22.7419C19.8228 23.3008 20.2758 23.7538 20.8346 23.7538C21.3935 23.7538 21.8465 23.3008 21.8465 22.7419Z",
    fill: "#F69D25"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8465 27.1677V26.7486C21.8465 26.1897 21.3935 25.7367 20.8346 25.7367C20.2758 25.7367 19.8228 26.1897 19.8228 26.7486V27.1677C19.8228 27.7265 20.2758 28.1796 20.8346 28.1796C21.3935 28.1796 21.8465 27.7265 21.8465 27.1677Z",
    fill: "#F69D25"
  })));
}

export default SvgExclamation;